import update from 'immutability-helper';
import {
    INTEGRATION_QB_TAXES_LOADED,
INTEGRATION_QB_TERM_LOADED,
INTEGRATION_QB_ACCOUNT_LOADED,
INTEGRATION_QB_CLASS_LOADED,
INTEGRATION_SET_QB_MODEL,
INTEGRATION_QB_MODEL_UPDATED_BY_FORM
} from '../actions/types';

export default function qb(state = {
    model: {
        income_acct_id: "0",
        expense_acct_id: "0",
        asset_acct_id: "0",
        inventory_class_id: "0",
        service_class_id: "0",
        ap_account_cad_id: "0",
        ap_account_usd_id: "0"
    },
    lists: {
        taxes: [],
        terms: [],
        classes: [],
        accounts: []
    }
}, action = {}) {
    switch(action.type) {
        case INTEGRATION_QB_MODEL_UPDATED_BY_FORM:
            return update(state, {
                model: {
                    [action.payload.field]:{$set: action.payload.value}
                }
            });

        case INTEGRATION_SET_QB_MODEL:
            return update(state, {
                model: {$set: action.payload}
            });

        case INTEGRATION_QB_ACCOUNT_LOADED:
            return update(state, {
                lists: {
                    accounts: {$set: action.payload}
                }
            });

        case INTEGRATION_QB_CLASS_LOADED:
            return update(state, {
                lists: {
                    classes: {$set: action.payload}
                }
            });

        case INTEGRATION_QB_TERM_LOADED:
            return update(state, {
                lists: {
                    terms: {$set: action.payload}
                }
            });

        case INTEGRATION_QB_TAXES_LOADED:
            return update(state, {
                lists: {
                    taxes: {$set: action.payload}
                }
            });

        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/stores/qb.js